'use client';

import { useContactFormStore, useNewsletterStore } from '$context/contactForm';
import { Url } from '$providers/Url';
import cn from 'classnames';
import React, { HTMLAttributes } from 'react';

import { Button } from '../Button/Button';
import { IButton } from '../Button/types';
import { IModalToggleButton } from './';

export function ModalToggleButton(
  props: IModalToggleButton &
    IButton &
    HTMLAttributes<HTMLElement> & { url?: Url },
) {
  const { type, text, inContentBlock, url, ...rest } = props;
  const { toggleContactForm } = useContactFormStore();
  const { toggleNewsletterSignup: toggleNewsletterForm } = useNewsletterStore();

  return (
    <Button
      {...rest}
      className={cn(
        'md:w-auto justify-center',
        typeof inContentBlock === 'undefined' || !inContentBlock
          ? 'w-full'
          : '',
      )}
      action={() => {
        if (type === 'newsletterSignup') toggleNewsletterForm();
        if (type === 'contactForm') toggleContactForm(url?.contactFormRole);
      }}
    >
      {text}
    </Button>
  );
}
